import { FC } from "react";
import { TableCell, TableHeadCell } from "@rothoblaas/design-system";
import { BooleanValue } from "../../../../components/ds2/BooleanValue";
import AdminCrudTable from "../../../../components/ui/AdminCrudTable";
import useI18n from "../../../../hooks/useTranslations";
import { ConnectorFamily } from "../../../../http/deckDesigner/types/connectorFamilies";
import useDeckConnectorFamiliesApi from "../../../../http/deckDesigner/useConnectorFamilies";
import ConnectorFamilyForm from "./ConnectorFamilyForm";

const AdminConnectorFamilies: FC = () => {
  const i18n = useI18n();
  const connectorFamiliesApi = useDeckConnectorFamiliesApi();
  const unitMm = i18n.translation.common.unitMm;

  return (
    <AdminCrudTable<ConnectorFamily>
      filterPrefix="connector_families"
      useList={connectorFamiliesApi.useDeckConnectorFamilies}
      head={
        <>
          <TableHeadCell align="left">{i18n.translation.common.name}</TableHeadCell>
          <TableHeadCell align="left">{i18n.translation.common.groovingMinHeight}</TableHeadCell>
          <TableHeadCell align="left">{i18n.translation.common.groovingMaxHeight}</TableHeadCell>
          <TableHeadCell align="left">{i18n.translation.common.groovingThickness}</TableHeadCell>
          <TableHeadCell align="left">
            {i18n.translation.deckDesignerModule.connectorFamilies.maxBoardThickness}
          </TableHeadCell>
          <TableHeadCell align="left">{i18n.translation.deckDesignerModule.connectorFamilies.isScrew}</TableHeadCell>
          <TableHeadCell align="left">
            {i18n.translation.deckDesignerModule.connectorFamilies.requiresBoardScrew}
          </TableHeadCell>
          <TableHeadCell align="left">{i18n.translation.deckDesignerModule.screwFamilies.plural}</TableHeadCell>
        </>
      }
      renderRow={(item) => (
        <>
          <TableCell>{item.name}</TableCell>
          <TableCell>{item.groovingMinHeight != null && `${item.groovingMinHeight} ${unitMm}`}</TableCell>
          <TableCell>{item.groovingMaxHeight != null && `${item.groovingMaxHeight} ${unitMm}`}</TableCell>
          <TableCell>{item.groovingThickness != null && `${item.groovingThickness} ${unitMm}`}</TableCell>
          <TableCell>{item.maxBoardThickness != null && `${item.maxBoardThickness} ${unitMm}`}</TableCell>
          <TableCell>
            <BooleanValue value={item.isScrew} />
          </TableCell>
          <TableCell>
            <BooleanValue value={item.requiresBoardScrew} />
          </TableCell>
          <TableCell>{item.screwFamilies.map((screwFamily) => screwFamily.name).join(", ")}</TableCell>
        </>
      )}
      visibilityAndOrder={{
        updateVisibility: (item, visibility) =>
          connectorFamiliesApi.updateDeckConnectorFamilyVisibility(item.code, { visibility }),
        updateOrder: (item, order) => connectorFamiliesApi.updateDeckConnectorFamilyOrder(item.code, { order }),
      }}
      renderForm={(item, onClose) => <ConnectorFamilyForm connectorFamily={item} onClose={onClose} />}
    />
  );
};

export default AdminConnectorFamilies;
